import React, { useCallback } from 'react'
import { useFormContext } from 'react-hook-form'

import { Stepper } from 'components'
import { ArtistStep, ConfirmationStep, ProductsStep, ProjectStep } from 'modules/ProjectCreate/containers'
import { stepsInfo } from 'modules/ProjectCreate/constants'

import './ProjectCreateStepper.scss'

const ProjectCreateStepper = () => {
  const { watch, reset, getValues } = useFormContext()
  const activeStep = watch('step')
  const setActiveStep = useCallback(
    (step: number) => {
      reset({
        ...getValues(),
        step
      })
    },
    [reset, getValues]
  )

  return (
    <Stepper
      activeStep={activeStep}
      stepsInfo={stepsInfo}
      className="stepper-container"
      setActiveStep={setActiveStep}
    >
      {activeStep === 0 ? (
        <ArtistStep />
      ) : activeStep === 1 ? (
        <ProjectStep />
      ) : activeStep === 2 ? (
        <ProductsStep />
      ) : (
        <ConfirmationStep />
      )}
    </Stepper>
  )
}

export default ProjectCreateStepper
